/* Package imports */
import { BrowserRouter } from 'react-router-dom';

/* Component imports */
import { AllRoutes } from './index';

const Routes = () => {
    return (
        <BrowserRouter>
            <AllRoutes />
        </BrowserRouter>
    );
};

export default Routes;
